import { render } from "./HospitalPhysicians.vue?vue&type=template&id=e2f3e75a"
import script from "./HospitalPhysicians.vue?vue&type=script&lang=js"
export * from "./HospitalPhysicians.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/hospitals/physicians/HospitalPhysicians.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e2f3e75a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e2f3e75a', __exports__)) {
    console.log('reload')
    api.reload('e2f3e75a', __exports__)
  }
  
  module.hot.accept("./HospitalPhysicians.vue?vue&type=template&id=e2f3e75a", () => {
    console.log('re-render')
    api.rerender('e2f3e75a', render)
  })

}


export default __exports__